import { OrganizationContextNotice } from '@/components/patterns/info-notice'
import { useState } from 'react'

export default function PriceChangesGlobalOrgNotice() {
  const [showAlert, setShowAlert] = useState(true)

  if (!showAlert) {
    return null
  }

  return (
    <OrganizationContextNotice onDismiss={() => setShowAlert(false)}>
      Price changes are florist-specific. Manage pricing inside the right florist account.
    </OrganizationContextNotice>
  )
}
